import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

/**
 * Visible breadcrumb trail. Pair with getBreadcrumbLD() for the JSON-LD.
 * items: [{ name, to }] — last item is the current page (no link).
 */
const Breadcrumbs = ({ items = [] }) => {
  if (!items.length) return null;
  return (
    <nav aria-label="Breadcrumb" className="text-sm text-chocolate-malt" data-testid="breadcrumbs">
      <ol className="flex flex-wrap items-center gap-1">
        {items.map((item, i) => {
          const last = i === items.length - 1;
          return (
            <li key={item.to || item.name} className="flex items-center gap-1">
              {last ? (
                <span aria-current="page" className="font-medium text-rabbit">{item.name}</span>
              ) : (
                <Link to={item.to} className="hover:text-burnt-coral underline-offset-4 hover:underline">{item.name}</Link>
              )}
              {!last && <ChevronRight className="w-4 h-4 opacity-50" aria-hidden="true" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
